import React from "react";
import PropTypes from "prop-types";
import "./css/servicesComponent.css";

const ServicesComponent = ({ services = [] }) => {
  return (
    <div className="row justify-content-center g-4">
      {services.map((service, index) => (
        <div
          key={index}
          className="col-12 col-lg-4 d-flex justify-content-center"
        >
          <div className="service-card shadow-lg h-100">
            <div className="service-image-wrapper">
              <img
                src={service.img}
                alt={service.title}
                className="service-image"
                onContextMenu={(e) => e.preventDefault()}
              />
            </div>

            <div className="service-body">
              <div className="service-title d-flex justify-content-center align-items-center mt-2">
                <div className="color-text-blanco-18-hv text-center">
                  {service.title}
                </div>
              </div>

              <div className="text-barlow-regular-blanco-hv mt-3 balance-text mb-3">
                {service.subtitle}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

ServicesComponent.propTypes = {
  services: PropTypes.any,
};

export default ServicesComponent;
